/**
 * @desc 上传PDA
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: string,
  params: API.basics.pdaVersion.upload.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/pda/upload`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
